
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const menuItems = [
    { label: '회사소개', href: '#about' },
    { label: 'ISO 인증', href: '#iso-certification' },
    { label: 'ISO 교육', href: '#iso-education' },
    { label: '경영 인증', href: '#management-certification' },
    { label: '기타 인증', href: '#other-certification' },
    { label: '경영 컨설팅', href: '#consulting' },
    { label: '문의하기', href: '#contact' }
  ];

  return (
    <nav className={`fixed w-full top-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 md:py-4">
        <div className="flex items-center justify-between">
          <a href="#" className="flex items-center gap-2 md:gap-3 cursor-pointer">
            <div className="w-8 h-8 md:w-10 md:h-10 bg-gradient-to-br from-teal-500 to-teal-600 rounded-lg flex items-center justify-center">
              <i className="ri-shield-check-line text-white text-base md:text-xl"></i>
            </div>
            <span className={`text-base md:text-xl font-bold transition-colors ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}>
              <span className="hidden sm:inline">유엔아이파트너스</span>
              <span className="sm:hidden">U&I Partners</span>
            </span>
          </a>

          <div className="hidden lg:flex items-center gap-8">
            {menuItems.map((item, index) => (
              <a
                key={index}
                href={item.href}
                className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  isScrolled 
                    ? 'text-gray-700 hover:text-teal-600' 
                    : 'text-white hover:text-teal-300'
                }`}
              >
                {item.label}
              </a>
            ))}
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden mt-3 pb-3 bg-white rounded-xl shadow-lg overflow-hidden">
            {menuItems.map((item, index) => (
              <a
                key={index}
                href={item.href}
                onClick={() => setIsMobileMenuOpen(false)}
                className="block px-5 py-3 text-gray-700 hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer text-sm border-b border-gray-100 last:border-b-0"
              >
                {item.label}
              </a>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
}
